import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnChanges,
    OnDestroy,
    OnInit
} from '@angular/core';
import {Anchor} from './anchor.interface';
import {ScrollToService} from '@services/scroll-to.service';
import {Subscription} from 'rxjs';
import {WindowEventsService} from '@services/window-events.service';
import {filter} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-page-inside-navigation',
    templateUrl: './page-inside-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageInsideNavigationComponent implements OnInit, OnChanges, OnDestroy {
    @Input() anchors: Anchor[] = [];

    private native: HTMLElement;

    private subs: Subscription[] = [];

    private allowScrollHandle = true;

    private lastActiveTargetId: string;

    /**
     * Тут сохраняем setTimeout, чтобы прерывать его работу
     */
    private preventScrollTimeout;

    constructor(
        private er: ElementRef,
        private cd: ChangeDetectorRef,
        private windowEvents: WindowEventsService,
        private route: ActivatedRoute,
    ) {
        this.native = this.er.nativeElement;
    }

    ngOnInit() {
        const fragment = this.route.snapshot.fragment;

        /**
         * При инициализации активным будет тот, на который показывает якорь в URL (fragment) или первый
         */
        if (this.anchors.length) {
            let hasActive = false;
            if (fragment) {
                hasActive = this.anchors.some((a) => {
                    a.active = a.targetId === fragment;
                    return a.active;
                });
            }

            if (!fragment || !hasActive) {
                this.anchors[0].active = true;
            }

        }

        /**
         * Прерываем обработку скролла, чтобы при инициализации и подматываниях к блоку при показе страницы
         * у нас активный пункт оставался неизменным и не пересчитывался
         * @type {boolean}
         */
        this.allowScrollHandle = false;
        this.preventScrollTimeout = setTimeout(() => {
            this.allowScrollHandle = true;
            this.preventScrollTimeout = null;
        }, 1500);

        /**
         * Подписываемся на смену видимого блока только после того, как инициализировалось начальное состояние,
         * чтобы уже был выставлен запрет на обработку скролла и существующее в windowEvents.visibleElementId$
         * не пошло в обработку раньше, чем приложении инициализировалось.
         */
        this.subs.push(
            this.windowEvents.visibleElementId$.pipe(
                filter(() => this.allowScrollHandle)
            ).subscribe((v) => this.onVisibleElementChange(v))
        );
    }

    ngOnChanges() {
        /**
         * Восстанавливаем активность выбранного элемента, так как она будет сброшена
         */
        if (this.lastActiveTargetId) {
            this.anchors.forEach(a => a.active = a.targetId === this.lastActiveTargetId);
        }
    }


    scrollToTarget(target: string) {
        this.allowScrollHandle = false;
        ScrollToService.toById(target);

        /**
         * На время запрещаем обрабатывать события скролла, чтобы при smooth scroll не возникало переопределений
         * активного шага и был активным тот, на который мы кликнули, а не тот, который оказался
         * видимый в процессе плавного скролла после того, как мы кликнули
         */
        if (this.preventScrollTimeout) {
            clearTimeout(this.preventScrollTimeout);
            this.preventScrollTimeout = null;
        }
        this.preventScrollTimeout = setTimeout(() => {
            this.allowScrollHandle = true;
            this.preventScrollTimeout = null;
        }, 1500);
    }

    setItemActive(item) {
        this.lastActiveTargetId = item.targetId;
        this.anchors.forEach(anchor => {
            if (item === anchor) {
                anchor.active = true;
                this.scrollToTarget(anchor.targetId);
            } else {
                anchor.active = false;
            }
        });
    }

    private onVisibleElementChange(elementId: string) {
        this.anchors.forEach(a => {
            a.active = a.targetId === elementId;

            if (a.active) {
                this.lastActiveTargetId = elementId;
            }
        });
        this.cd.detectChanges();
    }

    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
    }
}
